import { pageOpenRedirect, pageRequestUrl } from '../../../shared/page-open-rules'
import { pushAppPath } from './push-app-path'

let hops = 0

function openPageRedirect (router, application, page) {

  const target = pageOpenRedirect(page && page.pageOpen, page && page.uniqueTitle)

  if (!target || !application) {

    hops = 0
    return false
  }

  if (hops >= 3) {

    hops = 0
    return false
  }

  hops += 1

  if (target.pageUniqueTitle) {

    pushAppPath(router, `/${application}/${target.pageUniqueTitle}`)
    return true
  }

  if (target.url && typeof window !== 'undefined') {

    window.location.assign(target.url)
    return true
  }

  hops -= 1
  return false
}

export { pageRequestUrl, openPageRedirect }
